import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import FileDropzone from '../FileDropzone/FileDropzone';
import Api from '../../../services/Api';

const VideoCitation = ({
  onChanged,
  onRequestClose,
}) => {
  const onFileUploaded = (file) => {
    const data = {
      file_id: file[0],
      resource_type_id: 4,
      title: 'Video File',
    };
    Api.post('citations', data).then((response) => {
      if (response.status === 201) {
        if (onChanged) {
          onChanged(response.data);
        }
      }
    });
  };
  return (
    <div className="row">
      <div className="col-md-12">
        <FileDropzone
          onFilesChanged={onFileUploaded}
          endpoint="documents/upload"
          allowedFiles={{
            'video/*': ['.mp4', '.mpeg', '.mkv'],
          }}
        />
      </div>
      <div className="col-md-12 text-end mt-5">
        <Button variant="warning" onClick={onRequestClose} className="me-3">
          Close
        </Button>
      </div>
    </div>
  );
};

VideoCitation.propTypes = {
  onChanged: PropTypes.func,
  onRequestClose: PropTypes.func.isRequired,
};

VideoCitation.defaultProps = {
  onChanged: undefined,
};

export default VideoCitation;
